import { OrderTypes } from '@next/core-lib/cart';
import { TableColumn } from '@next/core-lib/table';

import { createOrderColumns } from './create-order-columns';
import { createPreSalesOrderColumns } from './create-presales-order-columns';
import { createReturnOrderColumns } from './create-return-order-columns';
import { createSalesOrderColumns } from './create-sales-order-columns';
import { CartComponent } from '../../cart.component';

export const createColumns = (
  componentRef: CartComponent,
  hasAtLeastAdvisorRole: boolean,
  featureFlags: string[],
  isTabOrSmallerDisplay: boolean,
  hasRemarksFeature: boolean,
): TableColumn[] => {
  switch (componentRef.cart?.type) {
    case OrderTypes.preSalesOrder:
      return createPreSalesOrderColumns(componentRef, hasAtLeastAdvisorRole);
    case OrderTypes.returnableOrder:
      return createReturnOrderColumns(componentRef);
    case OrderTypes.salesOrder:
    case OrderTypes.rushOrder:
    case OrderTypes.emergencyOrder:
    case OrderTypes.pickUpOrder:
    case OrderTypes.grainPreSalesOrder:
      return createSalesOrderColumns(componentRef, hasAtLeastAdvisorRole, featureFlags, isTabOrSmallerDisplay, hasRemarksFeature);
    default:
      return createOrderColumns(componentRef);
  }
};
